import HazardTable from '@app/domains/hazards/components/HazardTable'
import { Box, CircularProgress } from '@mui/material'
import { Suspense } from 'react'
import { DataTabKey } from '../types'
import { DataLayerTable } from './DataLayerTable'

export type RiskDataViewProps = {
  tab?: DataTabKey
}

export const DataLayerView = ({ tab = 'all' }: RiskDataViewProps) => {
  return (
    <Suspense
      fallback={
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress color="inherit" />
        </Box>
      }
    >
      {tab === 'hazards' ? <HazardTable /> : <DataLayerTable activeTab={tab} />}
    </Suspense>
  )
}

export default DataLayerView
